<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 i18n  id="modal-title">Newsletter</h1>
    </header>
    <section class="modal-body">
        <p i18n  class="text" *ngIf="subscribe">
            By clicking "Yes", you accept the terms and conditions of our newsletter. Read the terms and conditions <a href="https://ancytree.com/allmanna-kopvillkor/#nyhetsbrev" target="_blank">here</a>.
        </p>
        <p i18n  class="text" *ngIf="!subscribe">
            Are you sure you want to unsubscribe to our Newsletter?
        </p>
    </section>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" mat-dialog-close="success">
            Yes
        </button>
        <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
            Cancel
        </button>
    </footer>
</div>